// web/src/components/atoms/Toggle.tsx — DS.7 (sprint aos-ds-settings-modals,
// spec §2 D7 / D15).
//
// The As Oasis API over `@ds/data-input/Switch`. The wrapper is KEPT — the
// alternative (deleting the atom and importing `@ds` at the six call sites)
// loses the `settings-switch` default testid that three `SettingsPage` tests
// query and scatters the same decision six ways.
//
// `ToggleProps` is UNCHANGED, so `SettingsPage`'s six call sites are untouched
// `[medido: grep -c '<Toggle' web/src/pages/SettingsPage.tsx -> 6]`. The piece
// sets `role="switch"` and `aria-checked` on its own input
// (Switch.tsx:56-64), so `getByRole('switch')` and the `aria-checked` reads
// survive; `data-testid` rides the piece's `{...props}` spread onto that same
// input. The ONE enumerated assertion delta is `toHaveClass('bg-action')` ->
// `toBeChecked()`: the on-state colour is now a hashed CSS-module class, which
// is not a contract. `toBeDisabled()` survives unchanged (`<input disabled>`).

import Switch from '@ds/data-input/Switch';

export interface ToggleProps {
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
  disabled?: boolean;
  label?: string;
  'data-testid'?: string;
}

export function Toggle({
  checked,
  onCheckedChange,
  disabled = false,
  label,
  'data-testid': testId,
}: ToggleProps) {
  const id = label ? `toggle-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined;

  return (
    <Switch
      id={id}
      label={label}
      checked={checked}
      disabled={disabled}
      onChange={(e) => onCheckedChange(e.target.checked)}
      data-testid={testId ?? 'settings-switch'}
    />
  );
}
